import {Box, Button, Card, CardContent, CardHeader, Grid, TextField, Typography} from "@mui/material"
import HomeMadeSnackbar from "../../components/snackbars/HomeMadeSnackbar"
import {getAsiaUserFromLocalStorage} from "../../session/getAsiaUser"
import {useState} from "react"
import {useLingui} from "@lingui/react"
import {Controller, useForm} from "react-hook-form"
import httpReq from "../../services/httpReq"
import {msg} from "@lingui/macro"
import {useNavigate} from "react-router-dom"
import useMobile from "../../hooks/useMobile";

const ProfilePage = () => {
    const isMobile = useMobile();
    const navigate = useNavigate();

    const userResponse = getAsiaUserFromLocalStorage()

    const [user, setUser] = useState(userResponse)
    const [selectedUserRole, setSelectedUserRole] = useState(userResponse ? userResponse.profile : null)
    const { control, getValues } = useForm({
        mode: 'onChange',
        defaultValues: {
            username: user?.username,
            completeName: user?.completeName,
            email: user?.email,
            firstName: user?.firstName,
            lastName: user?.lastName
        }
    })
    const [userRolesList, setUserRolesList] = useState([])
    const { _ } = useLingui()
    const [isOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [snackbarValues, setSnackbarValues] = useState({
        btnColor: '',
        color: '',
        closeAction: true,
        message: ''
    })

    const updateUser = async () => {
        const values = getValues()
        const dt = Object.assign(user, values)

        const dataToSend = {
            id: dt.id,
            username: dt.username,
            firstName: dt.firstName,
            lastName: dt.lastName,
            email: dt.email,
            mobile: dt.mobile,
            profileFk: selectedUserRole.id
        }
        // dataToSend.authenticateResponse = null
        const res = await httpReq(`User/Update`, 'PATCH', dataToSend, true)
        if (!res.responseAnyError) {
            localStorage.removeItem('asiaUser')
            localStorage.setItem('asiaUser', JSON.stringify(res.responseData))
            setUser(res.responseData)
            setIsOpenSnackbar(true)
            setSnackbarValues({
                btnColor: 'white',
                closeAction: true,
                message: `User updated!`,
                color: 'green'
            })
        }
    }

    return (
        <>
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: `calc(100%)`,
                p: isMobile ? 1 : 4
            }}>
                <Card sx={{
                    width: isMobile ? '100%' : 600,
                    p: 3,
                    borderRadius: 4,
                    boxShadow: 10,
                    backgroundColor: 'white',
                    animation: 'fadeInUp 0.6s ease-out'
                }}>
                    <CardHeader
                        title={<Typography variant="h5" fontWeight="bold" textAlign="center">{user.completeName}</Typography>}
                        sx={{ mb: 2, p: 0 }}
                    />

                    <CardContent>
                        <Grid container spacing={2}>
                            {['username', 'completeName'].map((name) => (
                                <Grid item xs={12} key={name}>
                                    <Controller
                                        name={name}
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                label={_(msg`${name === 'username' ? 'Username' : 'Complete name'}`)}
                                                fullWidth
                                                margin="dense"
                                                variant="outlined"
                                                disabled
                                            />
                                        )}
                                    />
                                </Grid>
                            ))}

                            {['email', 'firstName', 'lastName'].map((name) => (
                                <Grid item xs={12} key={name}>
                                    <Controller
                                        name={name}
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <TextField
                                                {...field}
                                                label={_(msg`${name === 'firstName' ? 'First name' : name === 'lastName' ? 'Last name' : 'Email'}`)}
                                                fullWidth
                                                margin="dense"
                                                variant="outlined"
                                                error={!!fieldState.error}
                                                helperText={fieldState.error?.message}
                                            />
                                        )}
                                    />
                                </Grid>
                            ))}
                        </Grid>

                        <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
                            <Typography
                                variant='body2'
                                onClick={() => navigate('change-password')}
                                sx={{
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    fontWeight: 500,
                                    color: 'primary.main',
                                    '&:hover': {
                                        color: 'primary.dark'
                                    }
                                }}
                            >
                                Do you want to change your password?
                            </Typography>

                            <Button
                                variant="contained"
                                size="large"
                                onClick={updateUser}
                                sx={{ borderRadius: 3, px: 4, py: 1 }}
                            >
                                Save
                            </Button>
                        </Box>
                    </CardContent>
                </Card>

                {isOpenSnackbar &&
                    <HomeMadeSnackbar
                        setIsOpen={setIsOpenSnackbar}
                        btnColor={snackbarValues.btnColor}
                        closeAction={snackbarValues.closeAction}
                        color={snackbarValues.color}
                        message={snackbarValues.message}
                    />
                }
            </Box>

        </>
    )
}
export default ProfilePage